

export default function MainConfigOnScreenFactory(objectType: string) {
  switch (objectType) {
    default:
      return () => <div></div>;
  }
}
